import React, { useContext, useState, useEffect } from "react";
// import MediaQuery from 'react-responsive';
import { isMobile } from "react-device-detect";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "react-i18next";

import UIHelper from "../../../../helpers/UIHelper";
import { ButtonGroup, Container, TapButton, HomeButton } from "./HeaderStyles";
import { reducer } from "../../../../context";
import actionType from "../../../../context/actionType";
import StageRow from "../StageRow/StageRow";
import CountdownTimer from "../CountdownTimer/CountdownTimer";
import SearchBar from "../SearchBar/SearchBar";
import SearchDropdown from "../SearchDropdown/SearchDropdown";
import { MenuItem } from "../../../../interface/Server";
import Api from "../../../../helpers/Api";
import i18n_address from "../../../../i18n_addr";

const LANGUAGES = ["en", "zhTW", "cn"];

const selectedLng = {
  fontFamily: "Rambla",
  color: "#2c3c4e",
  marginLeft: 2,
  backgroundColor: "transparent",
  borderColor: "#2c3c4e",
};
const defaultLng = {
  fontFamily: "Rambla",
  color: "white",
  marginLeft: 2,
  backgroundColor: "#2c3c4e",
  borderColor: "#2c3c4e",
};

interface Props {
  menu: MenuItem[];
  setShowMenu: (show: boolean) => {};
}

const Header: React.FunctionComponent<Props> = (props) => {
  const { configReducer, assetsReducer, formReducer } = useContext(reducer);
  const { t, i18n } = useTranslation();
  const { t: t_addr, i18n: i18n_addr } = useTranslation("", {
    i18n: i18n_address,
  });
  const useChinese = i18n.language === "zhTW" || i18n.language === "cn";
  // const {filter} = assetsReducer.state;
  const [showResults, setShowResults] = useState(false);

  // TODO: add keyword search
  const onSearchKeyword = (
    keyword: string,
    callback: () => void = () => {}
  ) => {
    const headers = {
      "Content-Type": "application/json; charset=utf-8",
    };
    fetch(`${Api.path(window.location)}/es/asset`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        query: keyword,
        pageNumber: 1,
        pageSize: 10,
        index: "asset",
      }),
    })
      .then((result) => {
        return result.json();
      })
      .then((resJson) => {
        const searchResults = (resJson.data && resJson.data.dataList) || [];
        assetsReducer.dispatch({
          type: actionType.assets.SEARCH_RESULT_SUCCESSFUL,
          payload: { searchResults },
        });
        callback();
        setShowResults(true);
      });
  };
  useEffect(() => {
    if (window.location.href.indexOf("/donation/") === -1) {
      return;
    }
    const start = sessionStorage.getItem("START_TIME");
    if (start) {
      formReducer.dispatch({
        type: actionType.form.SET_START_TIME,
        payload: {
          startTime: new Date(JSON.parse(start)),
        },
      });
    }
  }, []);
  if (
    window.location.href.indexOf("/nameplate") > -1 &&
    !formReducer.state.formStep
  ) {
    formReducer.dispatch({
      type: actionType.form.START_FORM_STAGE,
      payload: {},
    });
  }
  if (
    window.location.href.indexOf("user/landing") > -1 &&
    !formReducer.state.formStep
  ) {
    formReducer.dispatch({
      type: actionType.form.GO_TO_FORM_STAGE,
      payload: {
        nextStep: 2,
      },
    });
  }
  if (
    window.location.href.indexOf("auth/") === -1 &&
    !!formReducer.state.formStep
  ) {
    formReducer.dispatch({
      type: actionType.form.RESET_FORM_STAGE,
      payload: {},
    });
  }
  const clearResults = () => {
    assetsReducer.dispatch({
      type: actionType.assets.CLEAR_SEARCH_RESULTS,
      payload: {},
    });
    setShowResults(false);
  };
  const onExpire = () => {
    toast.error("Session has expired. Logging out.");
    sessionStorage.setItem("START_TIME", "");
    sessionStorage.setItem("SESSION_TOKEN", "");
    formReducer.dispatch({
      type: actionType.form.LOGOUT_SUCCESSFUL,
      payload: {},
    });
    setTimeout(() => {
      window.location.href = "/auth/user/landing";
    }, 2000);
  };

  const formInProgress =
    !!formReducer.state.formStep && formReducer.state.formStep > 0;
  return (
    <>
      <Container isMobile={isMobile}>
        <div style={isMobile ? { display: "flex", flexDirection: "row" } : {}}>
          {
            isMobile && (
              // disable menu for now (according to KD, under no situation will use the menu)
              <></>
            )
            // <div style={{ alignContent: 'center', verticalAlign: 'center', display: 'flex' }} onClick={() => props.setShowMenu(true)}>
            //     {/* {UIHelper.renderSVG('menu', { width: 24, objectFit: 'contain', marginLeft: 16 })} */}
            //     <img alt={'menu'} src={`/donation/assets/icons/menu.svg`} style={{ width: 24, objectFit: 'contain', marginLeft: 16 }} />
            // </div>
          }
          {/* {showMenu && <ButtonGroup isMobile style={{ position: 'absolute', backgroundColor: 'white', left: 48, top: 12, width: '80%', zIndex: 100 }}>
                        {configReducer.state.menu && configReducer.state.menu.length > 0 ? configReducer.state.menu.map((tap, index) => (
                                <TapButton useChinese={useChinese} href={tap.URL} key={index} style={{ borderStyle: 'solid', width: '100%', borderWidth: 0.5 }}>
                                    {tap.title}
                                </TapButton>
                            )
                        ) : <Spinner animation="border" size="sm" variant="secondary" />}
                    </ButtonGroup>} */}
          <div
            style={isMobile ? { padding: "17px 16px 17px 16px", flex: 1 } : {}}
          >
            <HomeButton
              onClick={() => (window.location.href = t("logoRedirectURL"))}
              isMobile={isMobile}
            >
              {/* {UIHelper.renderSVG('logo-black', { height: '100%' })} */}
                {/* /donation/assets/icons/logo-black.svg */}              
              <img
                alt={"WKCDA Main Logo"}
                src={`/donation/assets/icons/logo_black_wide.png`}
                style={{ height: "100%", width: 172 }}
              />
            </HomeButton>
          </div>
          {isMobile &&
            formReducer.state.startTime &&
            formReducer.state.formStep &&
            formReducer.state.formStep > 1 && (
              <CountdownTimer
                startTime={formReducer.state.startTime}
                onExpireCallback={onExpire}
                isMobile={isMobile}
              />
            )}
        </div>
        {formReducer.state.screen !== "completion" ? (
          !!formReducer.state.formStep && formReducer.state.formStep > 0 ? (
            <>
              <StageRow
                currentStep={formReducer.state.formStep - 1}
                isGeneralProject={!!formReducer.state.selectedProject}
                isMobile={isMobile}
              />
              {!isMobile &&
                formReducer.state.startTime &&
                formReducer.state.formStep > 1 && (
                  <CountdownTimer
                    startTime={formReducer.state.startTime}
                    onExpireCallback={onExpire}
                    isMobile={isMobile}
                  />
                )}
            </>
          ) : (
            <>
              <div
                style={{
                  flex: 1,
                  ...(isMobile
                    ? {
                        marginBottom: 10,
                        marginTop: 10,
                        paddingTop: 10,
                        marginLeft: 16,
                        marginRight: 16,
                      }
                    : {}),
                }}
              >
                <div style={{ display: "none" }}>
                  <SearchBar onChange={onSearchKeyword} isMobile={isMobile} />
                  {showResults && (
                    <SearchDropdown
                      results={assetsReducer.state.searchResults || []}
                      onClickOutside={clearResults}
                    />
                  )}
                </div>
              </div>
              {
                !isMobile && <></>
                //  <ButtonGroup>
                //     {configReducer.state.menu && configReducer.state.menu.length > 0 ? configReducer.state.menu.map((tap, index) => (
                //             <TapButton isChinese={useChinese} href={tap.URL} key={index}>
                //                 {tap.title}
                //             </TapButton>
                //         )
                //     ) : <Spinner animation="border" size="sm" variant="secondary" />}
                // </ButtonGroup>
              }
              {!isMobile &&
                LANGUAGES.map((lng, index) => (
                  <button
                    key={index}
                    onClick={() => {
                      i18n.changeLanguage(lng);
                      i18n_addr.changeLanguage(lng);
                    }}
                    style={i18n.language == lng ? selectedLng : defaultLng}
                  >
                    {t(`${lng}`)}
                  </button>
                ))}
            </>
          )
        ) : null}
      </Container>
    </>
  );
};

export default Header;
